export let PPTStorage;

export function setStorage( storage ) {
  PPTStorage = storage;
}
